import { Dispatch, SetStateAction } from "react";
import { ThreeDPQuizResultsType, UserType } from "@WahooFitness/cloud-client-types";
import useThreeDPQuiz from "./useThreeDPQuiz";
import Quiz from "../Quiz";

interface Props {
  user: UserType;
  setResults: Dispatch<SetStateAction<ThreeDPQuizResultsType | undefined>>;
  setError: Dispatch<SetStateAction<string | undefined>>;
  setPage: Dispatch<SetStateAction<number>>;
  skipEducation: boolean;
  onFirstStepBack?: () => void;
}

function ThreeDPQuiz({
  user,
  setResults,
  setError,
  setPage,
  skipEducation,
  onFirstStepBack,
}: Props) {
  const quizProps = useThreeDPQuiz(
    user,
    setResults,
    setPage,
    setError,
    skipEducation,
    onFirstStepBack
  );
  return <Quiz {...quizProps} />;
}

export default ThreeDPQuiz;
